import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { type Theme } from '@mui/material/styles'; // Import the Theme type
import { strings } from 'i18n/Strings';

interface OnfidoDocVerifyProps {
  imageUrlFront?: string;
  imageUrlBack?: string;
  imageUrlFace?: string;
  imageAddressFront?: string;
  addressType?: string;
  imageType?: string;
}

const formatOnfidoLabel = (value: string): string =>
  value
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const OnfidoDocVerify = (data: OnfidoDocVerifyProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={classes.boxStyle}>
      {/* Documents */}
      <Paper className={classes.paperStyle}>
        <Typography variant="h5" gutterBottom>
          {strings.displayText.documentType}:{' '}
          {formatOnfidoLabel(data.imageType ?? '')}
        </Typography>
        <Box className={classes.imageContainer}>
          <img
            className={classes.imageStyle}
            src={data.imageUrlFront}
            alt="Document Image Front"
          />
          {data.imageUrlBack && (
            <img
              className={classes.imageStyle}
              src={data.imageUrlBack}
              alt="Document Image Back"
            />
          )}
        </Box>
      </Paper>

      {/* Photos */}
      <Paper className={classes.paperStyle}>
        <Typography variant="h5" gutterBottom>
          {strings.displayText.photos}
        </Typography>
        <Box className={classes.imageContainerSingle}>
          <img
            className={classes.imageStyle}
            src={data.imageUrlFace}
            alt="Face Image"
          />
        </Box>
      </Paper>

      {/* Proof of Address */}
      <Paper className={classes.paperStyle}>
        <Typography variant="h5" gutterBottom>
          {strings.displayText.proofOfAddress}:{' '}
          {formatOnfidoLabel(data.addressType ?? '')}
        </Typography>
        <Box className={classes.imageContainerSingle}>
          <img
            className={classes.imageStyleSingle}
            src={data.imageAddressFront}
            alt="Address Image"
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default OnfidoDocVerify;

const useStyles = makeStyles((theme: Theme) => ({
  boxStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
  },
  paperStyle: {
    padding: theme.spacing(3),
    margin: theme.spacing(2),
    maxWidth: 600,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  imageContainerSingle: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  imageStyle: {
    height: 'auto',
    maxWidth: 600,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
  },
  imageStyleSingle: {
    width: '100%',
    height: 'auto',
    maxWidth: 300,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
  },
}));
